import React from 'react';
import moment from 'moment';
import modelService from '../../services/modelservice';

export default class ModelView extends React.Component {
  state = {
    view: 'list',
    editedItem: null,
    items: null
  };

  componentDidMount() {
    return this.getItems();
  }

  componentWillReceiveProps(nextProps) {

    if (this.props !== nextProps) {
      return modelService.getItems(nextProps.model, nextProps.query, nextProps.sort)
        .then(this.saveItems.bind(this));
    }

  }

  getItems() {
    return modelService.getItems(this.props.model, this.props.query, this.props.sort)
      .then(this.saveItems.bind(this));
  }

  saveItems(items) {
    this.setState({
      items
    });
  }

  editItem(item) {
    this.setState({
      editedItem: item,
      view: 'edit'
    });
  }

  deleteItem(item) {
    return modelService
      .deleteItem(this.props.model, item)
      .then(this.getItems.bind(this));
  }

  createItem(item) {
    return modelService
      .createItem(this.props.model, item, this.props.customPathCreate, this.props.fields)
      .then(this.getItems.bind(this));
  }

  updateItem(item) {
    if (item.id) {
      return modelService
        .updateItem(this.props.model, item, this.props.customPathUpdate, this.props.fields)
        .then(this.getItems.bind(this))
        .then(this.showList.bind(this));
    } else {
      return this.createItem(item)
        .then(this.showList.bind(this));
    }
  }

  cancelEdit() {
    this.setState({
      editedItem: null,
      view: 'list'
    });
  }

  showList() {
    this.setState({
      view: 'list'
    });
  }

  showEdit() {
    this.setState({
      view: 'edit'
    });
  }

  updateItemFromActionButton(item, button) {
    let newItem = Object.assign({}, item, {
      [button.property]: button.value
    });

    if (button.prompt) {
      newItem[button.promptProperty] = prompt(button.prompt);
    }

    return this.updateItem(newItem);
  }

  onActionButtonClick(item, button, ev) {

    ev.preventDefault();

    button.action(item);

  }

  renderListView(items, fields, style) {
    const renderedItemFields = fields.map(field => <th>{field.name}</th>);

    const renderedItems = items.map(item => {
      const itemFields = fields.map(field => <td>{field.format ? field.format(item[field.propertyDisplay || field.property]) : item[field.propertyDisplay || field.property]}</td>);
      const editButton = this.props.update ? <button className="btn btn-sm btn-info u-m-r-15 u-m-b-15" onClick={this.editItem.bind(this, item)}>Edit</button> : null;
      const deleteButton = this.props.delete ? <button className="btn btn-sm btn-danger u-m-r-15 u-m-b-15" onClick={this.deleteItem.bind(this, item)}>Delete</button> : null;

      let fieldActionButtons = null;

      if (this.props.fieldActionButtons) {
        fieldActionButtons = this.props.fieldActionButtons.map(button => {
          return (
            <button className="btn btn-sm u-m-r-15 u-m-b-15" style={button.style || {}} onClick={button.action ? this.onActionButtonClick.bind(this, item, button) : this.updateItemFromActionButton.bind(this, item, button)}>
              {button.name}
            </button>
          );
        });
      }

      let trStyle = {};

      if (style) {
        style.forEach(st => {
          if (item[st.compare] === st.value) {
            trStyle = st.true;
          }
        });
      }

      return (
        <tr style={trStyle}>
          {itemFields}
          <td>
            {editButton}
            {deleteButton}
            {fieldActionButtons}
          </td>
        </tr>
      );
    });

    const createButton = this.props.create ? <button className="btn btn-success" onClick={this.editItem.bind(this, {})}>Create</button> : null;

    const title = !this.props.title ? null: (
      <div className="u-m-b-15">
        <h6>{this.props.title}</h6>
      </div>
    );

    let rendered = null;

    if (items && items.length > 0) {
      rendered = (
        <table className="table table-striped table-bordered table-responsive">
          <thead>
          <tr>
            {renderedItemFields}
            <th>Actions</th>
          </tr>
          </thead>
          <tbody>
          {renderedItems}
          </tbody>
        </table>
      );
    } else {
      rendered = (
        <h6>There are no items. Try creating new ones.</h6>
      );
    }

    return (
      <div>
        {title}

        <div className="u-m-b-15">
          {createButton}
        </div>

        {rendered}
      </div>
    );
  }

  updateFieldForEditedItem(field, event) {
    let editedItem = this.state.editedItem;

    if (field.type === 'image' || field.type === 'file') {
      editedItem[field.property] = event.target.files[0];
    } else if (field.type === 'boolean') {
      editedItem[field.property] = event.target.checked;
    } else {
      editedItem[field.property] = event.target.value;
    }

    this.setState({
      editedItem
    });
  }

  renderEditView(editedItem, fields) {
    const inputs = fields.map(field => {
      let renderedInput = null;
      let inputProps = {
        className: 'form-control',
        value: editedItem[field.property] ? editedItem[field.property] : '',
        onChange: this.updateFieldForEditedItem.bind(this, field)
      };

      if (field.type === 'text') {
        inputProps.type = 'text';

        renderedInput = <input {...inputProps} />;
      } else if (field.type === 'bigtext') {
        renderedInput = <textarea {...inputProps}></textarea>;
      } else if (field.type === 'date') {
        inputProps.type = 'datetime-local';

        inputProps.value = moment(inputProps.value).format('YYYY-MM-DDTHH:mm');

        renderedInput = <input {...inputProps} />;
      } else if (field.type === 'number') {
        inputProps.type = 'number';

        renderedInput = <input {...inputProps} />;
      } else if (field.type === 'image' || field.type === 'file') {
        inputProps.type = 'file';
        delete inputProps.value;

        renderedInput = <input {...inputProps} />;
      } else if (field.type === 'select') {
        const options = field.options.map(option => {
          return (
            <option value={option.value}>{option.display}</option>
          );
        });

        if (inputProps.value && field.formatValue) {
          inputProps.value = field.formatValue(inputProps.value);
        }

        renderedInput = (
          <select {...inputProps}>
            <option></option>
            {options}
          </select>
        );

        if (field.edit === false) {
          renderedInput = null;
        }
      } else if (field.type === 'boolean') {
        inputProps.type = 'checkbox';
        inputProps.checked = inputProps.value === true;

        renderedInput = <input {...inputProps} />;
      } else if (field.type === 'color') {
        inputProps.type = 'color';

        renderedInput = <input {...inputProps} />;
      }  else if (field.type === 'email') {
        inputProps.type = 'email';

        renderedInput = <input {...inputProps} />;
      }

      return (
        <div className="form-group">
          <label>{field.name}</label>
          {renderedInput}
        </div>
      );
    });

    return (
      <div className='modelview-edit'>
        {inputs}

        <button className="btn btn-sm btn-success u-m-r-15" onClick={this.updateItem.bind(this, this.state.editedItem)}>Save</button>
        <button className="btn btn-sm btn-default" onClick={this.cancelEdit.bind(this)}>Cancel</button>
      </div>
    );
  }

  render() {
    let content = null;

    if (this.state.view === 'list' && this.state.items) {
      content = this.renderListView(this.state.items, this.props.fields, this.props.style);
    } else if (this.state.view === 'edit' && this.state.editedItem) {
      content = this.renderEditView(this.state.editedItem, this.props.fields);
    }

    return content;
  }
}



// WEBPACK FOOTER //
// ./src/components/modelview/index.js